"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalPresenterContainer = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../helpers");
const Modal_1 = require("../..");
function ModalPresenterContainer({ modal, containerRef }) {
    const state = (0, helpers_1.useStateValue)([]);
    modal.present = function present(renderer, view) {
        const id = Math.random().toString(16);
        const dismiss = () => {
            state.updateValue((prevValue) => {
                return prevValue.filter((i) => i.id !== id);
            });
        };
        state.updateValue((prevValue) => {
            const element = renderer(dismiss);
            if (!element) {
                return prevValue;
            }
            return [
                ...prevValue,
                {
                    id,
                    element: react_1.default.createElement(Modal_1.Modal, {
                        isShown: true,
                        render: () => element,
                        containerRef,
                        view
                    })
                }
            ];
        });
        return dismiss;
    };
    modal.dismissAll = function dismissAll() {
        state.setValue([]);
    };
    modal.dismissLatest = function dismissAll() {
        state.updateValue((prevValue) => {
            if (!prevValue.length) {
                return prevValue;
            }
            return prevValue.slice(0, prevValue.length - 1);
        });
    };
    modal.presentPage = function presentPage(renderer) {
        return modal.present(renderer, Modal_1.MODAL_VIEW.page);
    };
    modal.presentFullPage = function presentPage(renderer) {
        return modal.present(renderer, Modal_1.MODAL_VIEW.fullPage);
    };
    return react_1.default.createElement(react_1.default.Fragment, { key: 'modal-manager-container-fragment' }, state.getValue().map((item) => {
        return react_1.default.createElement(react_1.default.Fragment, {
            key: item.id
        }, item.element);
    }));
}
exports.ModalPresenterContainer = ModalPresenterContainer;
//# sourceMappingURL=ModalPresenterContainer.js.map